import type {
  PatientMedicalAidOnboardRequest,
  PatientOnboardResponse,
  PatientPrivateOnboardRequest,
} from '@quromedical/models';
import { trpcClient } from 'trpc';

export class OnboardApi {
  public onboardPrivate = async (
    request: PatientPrivateOnboardRequest,
  ): Promise<PatientOnboardResponse> => {
    const result =
      await trpcClient.patient.createPrivatePatient.mutate(request);

    return result;
  };

  public onboardMedicalAid = async (
    request: PatientMedicalAidOnboardRequest,
  ): Promise<PatientOnboardResponse> => {
    const result =
      await trpcClient.patient.createMedicalAidPatient.mutate(request);

    return result;
  };
}
